<template>
  <el-dialog
    append-to-body
    :visible.sync="innerVisible"
    :title="$t('Warehouse.ContainerNo')"
    width="450px"
    height="300px"
    class="station-edit-dialog"
    :close-on-click-modal="false"
  >
    <div v-if="innerVisible" class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="128px" label-position="left">
        <el-form-item :label="$t('Warehouse.PerContainerNo')">
          <el-input v-model="shipmentId" v-uppercase disabled :no="'shipmentId'" style="width: 228px" />
        </el-form-item>
        <el-form-item v-if="typeSummary" :label="$t('Warehouse.boxNum')">
          <el-input v-model="boxesNumber" disabled :no="'boxesNumber'" style="width: 228px" />
        </el-form-item>
        <el-form-item :label="$t('Warehouse.boxSeq')">
          <el-select v-model="boxSeqLen" :disabled="!typeSummary && !!containerSeq" style="width: 80px;margin-right: 8px">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-input v-model="startSeq" :no="'startSeq'" style="width: 50px;margin-right: 8px" @input="onInputStartSeq" />
          <span v-if="typeSummary" style="font-family: 'Open Sans', Arial, sans-serif">——</span>
          <el-input v-if="typeSummary" v-model="endSeq" :no="'endSeq'" disabled style="width: 50px;margin-left: 8px" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button type="primary" :no="'save'" @click="saveCallBack">{{ $t('common.btn.save') }}</el-button>
      <el-button :no="'cancel'" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'ContainerNoEditor',
  props: {
    visible: { type: Boolean, required: true },
    shipmentId: { type: String, required: true },
    boxesNumber: { type: Number, default: 0 },
    source: { type: String, default: 'detail' },
    containerNo: { type: String, default: '' },
    warehouseInDetailList: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      // 1 - 3位长度
      // 2 - 6位长度
      types: [],
      boxSeqLen: 6,
      startSeq: 1,
      endSeq: 0,
      boxSeq: '',
      containerSeq: ''
    }
  },
  computed: {
    typeSummary() {
      return this.source === 'summary'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      this.calBoxSeqLen()
      if (this.typeSummary) {
        this.calEndSeq()
      }
      this.types.push({ label: this.$t('Warehouse.boxSeqType3'), value: 3 })
      this.types.push({ label: this.$t('Warehouse.boxSeqType6'), value: 6 })
    },
    calBoxSeqLen() {
      if (this.containerNo.indexOf('-') !== -1) {
        const firstContainerNo = this.containerNo.split('-')[0]
        this.containerSeq = firstContainerNo.substring(this.shipmentId.length)
      } else {
        this.containerSeq = this.containerNo.substring(this.shipmentId.length)
      }
      if (this.containerSeq) {
        this.boxSeqLen = this.containerSeq.length
      }
    },
    calEndSeq() {
      this.endSeq = Number(this.startSeq) + Number(this.boxesNumber) - 1
    },
    onInputStartSeq() {
      this.calEndSeq()
    },
    saveCallBack() {
      if (!this.saveCheck()) {
        return
      }
      const startSeqFmt = this.startSeq.toString().padStart(this.boxSeqLen, '0')
      let containerNo = ''
      let result = {}
      if (this.typeSummary) {
        containerNo = this.shipmentId + startSeqFmt + '-' + this.endSeq
        result = {
          startSeq: this.startSeq,
          boxSeqLen: this.boxSeqLen,
          containerNo: containerNo
        }
      } else {
        containerNo = this.shipmentId + startSeqFmt
        // 检查重复containerNo
        if (this.verifyContainerNoDuplicate(containerNo)) {
          return
        }
        result = {
          containerNo: containerNo
        }
      }
      const saveEvent = this.typeSummary ? 'summarySaveCallBack' : 'detailSaveCallBack'
      this.$emit(saveEvent, result)
      this.$emit('close')
    },
    saveCheck() {
      if (!this.startSeq) {
        this.$message.warning(this.$t('Warehouse.boxSeqNotNull'))
        return false
      }
      if (Number(this.boxSeqLen) === 3) {
        if (Number(this.endSeq) > 999) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.boxSeqTooLong'), 999))
          return false
        }
      } else if (Number(this.boxSeqLen) === 6) {
        if (Number(this.endSeq) > 999999) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.boxSeqTooLong'), 999999))
          return false
        }
      }
      return true
    },
    // 验证containerNo是否重复
    verifyContainerNoDuplicate(containerNo) {
      for (const detail of this.warehouseInDetailList) {
        if (containerNo === detail.containerNo) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), containerNo))
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
</style>
